import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";

// ionic
import { IonContent } from '@ionic/angular';

// rxjs
import { Subject } from 'rxjs';
import { takeUntil } from "rxjs/operators";

// components
import { ProfileEditComponent } from "../../components/profile-edit/profile-edit.component";

// extends
import { BasePage } from "../base";

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.page.html',
    styleUrls: ['./edit-profile.page.scss'],
})
export class EditProfilePage extends BasePage implements OnInit, OnDestroy {

    @ViewChild(ProfileEditComponent) profileEdit: ProfileEditComponent;

    @ViewChild(IonContent) content: IonContent;

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    // handlers for events
    videoShowHandler;

    /**
     * constructor
     *
     */
    constructor(

    ) {
        super();
    }

    /**
     * on init
     *
     * @return void
     */
    ngOnInit() {
        // this.router.events.pipe(
        //     takeUntil(this.ngUnsubscribe)
        // ).subscribe((event) => {
        //     // using url from NavigationEnd instance, because route.snapshot was not sometimes updated...
        //     if (event instanceof NavigationEnd) {
        //         let url = event.url.replace(this.plt.defaultLink, '');
        //         if (url == '/edit-profile') {
        //             this.refresh();
        //             // scroll to top after navigation end...
        //             setTimeout(() => {
        //                 if (this.content) {
        //                     // TODO[jg] - triggering error...
        //                     //this.content.scrollToTop(0)
        //                 }
        //             }, 250);
        //         }
        //     }
        // });

        this.eventService.getCurrentEvent().pipe(
            takeUntil(this.ngUnsubscribe)
        ).subscribe(
            (event) => {

                this.event = event;

                this.videoShowHandler = (videoLink: string, direct: boolean = false) => {
                    // show modal with video
                    if (!this.plt.videoOpened) {
                        this.plt.videoOpened = true;
                        this.showVideo(videoLink, direct);
                    }
                }

                this.appEvents.subscribe('video:show', this.videoShowHandler);
            });
    }

    ionViewWillEnter() {
        if (this.plt.tabMenu) {
            this.profileEdit.refresh();
        }
    }

    /**
      * refresh profile edit component
      *
      * @return void
      */
    public refresh($event?) {
        // refresh component
        this.profileEdit.refresh($event);
    }


    /**
     * on destroy
     */
    ngOnDestroy() {

        if (this.videoShowHandler) {
            this.appEvents.unsubscribe('video:show', this.videoShowHandler);
        }

        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
